/* eslint-disable */
import { mapGetters, mapMutations, mapState } from "vuex";
import { consoleWarn, getPaddingAndMargin } from "@/assets/js/Renderer/renderFns";
import mixinsEvents from "@/components/UserInterfaces/mixins/events";
import { PROP_MAPPINGS } from "@/components/UserInterfaces/renderer/utils/mappings";

export default {
    props: {
        component: { type: Object, required: true },
        componentProperties: { type: Object, required: true },
        componentConfig: { type: Object, required: true },
        path: { type: Array, default: () => [] },
        interfaceData: { type: Object, default: () => ({}) },
        namespace: { type: String, default: "" },
        teleportTo: { type: String, default: "" },
        componentData: [Object, Array]
    },
    mixins: [mixinsEvents],
    data() {
        return {
            scrollBehavior: "smooth",
            // scrollBehavior: "instant",
            logWarn: false,
            guid: this.component.guid,
            localPath: [...this.path],
            showPath: false,
            componentType: this.componentProperties.__component,
            renderData: { value: null },
            isNewRender: true
        };
    },
    computed: {
        ...mapState("components", ["live", "designer", "activeComponent", "selectPath", "futureValues"]),
        styles() {
            const { padding, margin } = this.componentProperties.__generics;
            return getPaddingAndMargin(padding || [], margin || []);
        },
        computedProps() {
            const { props: cfgProps } = this.componentConfig;
            const props = {};

            (cfgProps || []).forEach((prop) => {
                const mapping = PROP_MAPPINGS[prop];
                props[prop] = mapping ? this[mapping] : this.getComputedProp(prop, props);
            });

            return props;
        },
        handlers() {
            const handlers = {};

            ([...new Set(this.componentConfig.localEvents || [])]).forEach(eventEntry => {
                handlers[eventEntry] = (...args) => { this.localEvents(eventEntry, ...args); };
            });

            return handlers;
        }
    },
    created() {
        this.localPath.push(this.guid);
    },
    mounted() {
        this.unwatchTeleport = this.$watch("teleportTo", this.handleTeleport, { immediate: true });
        this.unwatchSelect = this.$watch("selectPath", this.handleSelectPath, { immediate: true });
    },
    beforeDestroy() {
        this.unwatchTeleport && this.unwatchTeleport();
        this.unwatchSelect && this.unwatchSelect();
    },
    methods: {
        ...mapMutations("components", ["setActiveComponent"]),
        handleTeleport(portPath) {
            if (portPath) {
                const { [this.guid]: pathEntry = null } = this.$store.state.components.goToPath;

                if (pathEntry && (pathEntry.exactPath === this.path.join(","))) {
                    if (pathEntry.hasOwnProperty("goTo")) {
                        this.triggerHandler(pathEntry.goTo);
                    }

                    if (pathEntry.last) {
                        this.scrollToComponent();
                    }
                }
            }
        },
        handleSelectPath(selectPathList) {
            if (selectPathList.length) {
                const pathIndex = selectPathList.indexOf(this.guid);

                if (pathIndex !== -1) {
                    if (pathIndex === selectPathList.length - 1) {
                        this.scrollToComponent();
                        this.setActiveComponent(this.guid);
                    } else {
                        const { slots, namespace } = this.componentConfig;

                        if (slots || namespace) {
                            this.triggerHandler(slots ? selectPathList[pathIndex + 1] : 0);
                        }
                    }
                }
            }
        },
        scrollToComponent() {
            const { instanceRef } = this.$refs;
            if (instanceRef) {
                // instanceRef.$el.scrollIntoView({ behavior: this.scrollBehavior, block: "start", inline: "nearest" });
                instanceRef.$el.scrollIntoView({ behavior: this.scrollBehavior, block: "center", inline: "center" });
            } else {
                console.log("not found");
            }
        },
        triggerHandler(goToTarget) {
            const { instanceRef } = this.$refs;
            if (instanceRef) {
                instanceRef["goToHandler"](goToTarget);
            }

        },
        updateActiveComponent(ev) {
            if (this.designer && !this.live) {
                const toggleActive = () => {
                    this.setActiveComponent(this.guid === this.activeComponent ? null : this.guid);
                };

                if (this.componentConfig.slots) {
                    const isSlot = ev.target.closest(`.${this.componentConfig.slotClass}`);
                    if (isSlot) {
                        this.setActiveComponent(this.guid);
                    } else {
                        toggleActive();
                    }
                } else {
                    toggleActive();
                }
            }
        },
        guidToCodeNew(guid) {
            const { [guid]: ctrl } = this.$store.state.components.properties;

            return (ctrl && ctrl.__generics.code) || guid;
        },
        localEvents(eventName /* payload */) {
            const { __events: events = {}, __customEvents: customEvents = {} } = this.componentProperties;
            const script = events[eventName] || customEvents[eventName];
            // console.log(this.guid);

            // console.log(payload);
            // console.log(this.componentProperties);
            // eslint-disable-next-line no-new-func

            this.__executeScript({ fn: Function(`${script};`), guid: this.guid });

            // this.__executeScript()
            // console.log(this.guidToCode(this.guid));
            // console.log(this.namespace);
            // console.log(this.localPath);
            // console.log(eventName);
            // console.log(payload);
        },
        getComputedProp(prop) {
            let propValue;

            switch (prop) {
                case "values":
                    propValue = [
                        { value: "test1", label: "Test 1" },
                        { value: "test2", label: "Test 2" },
                        { value: "test3", label: "Test 3" }
                    ];
                    break;
                case "path":
                    propValue = this.localPath.join(",");
                    break;
                case "slots":
                    propValue = this.getComponentSlots();
                    break;
                case "mandatory":
                    propValue = { show: false };
                    break;
                case "map":
                    propValue = this.getComponentMapType();
                    break;
                case "readOnly":
                case "isMandatory":
                    propValue = false;
                    break;
                case "events":
                    propValue = {};
                    break;
                default:
                    propValue = undefined;
                    consoleWarn("Missing prop '%s' on %s with code [%s]", prop, this.guid, this.guidToCodeNew(this.guid));
            }

            return propValue;
        },
        getComponentSlots() {
            const slots = [];
            if (this.componentConfig.slots) {
                const componentsProperties = this.$store.state.components.properties;

                (this.component.body || []).forEach(slot => {
                    slots.push({ guid: slot.guid, label: componentsProperties[slot.guid].label });
                });
            }

            return slots;
        },
        getComponentMapType() {
            const getMapAttributes = attributes => {
                const data = { type: null, key: null };
                const { set } = attributes;

                if (set && set.startsWith("m_")) {
                    const pathList = set.substring(2).split(".");

                    if (pathList.length > 1) {
                        const { modelClasses } = this.$store.state.components.parsed;
                        let cursor = modelClasses[pathList.splice(0, 1)[0]];

                        pathList.forEach(node => { cursor = cursor && cursor.fields ? cursor.fields[node] : null; });
                        if (cursor) {
                            data.type = cursor.type;
                            data.key = cursor.key;
                        }
                    }
                }

                return data;
            };

            return getMapAttributes(this.componentProperties);
        }
    }
};
